import moment from 'moment'
const Functions = {
    install (Vue, options) {
    	Vue.prototype.$moment = moment
    	Vue.prototype.$today = function() {
			return this.$moment()
		},
        Vue.prototype.$noId = function(column) {
            // return !column.includes('_id') // breaks IE
            return !(column.indexOf('_id') >= 0)
        }
        Vue.prototype.$formatColumn = function(column) {
            return column.split('_').join(' ').replace( /\b./g, a => a.toUpperCase() )
        }
		Vue.prototype.$getCookie = function(name) {
		    var re = new RegExp(name + "=([^;]+)");
		    var value = re.exec(document.cookie);
		    return (value != null) ? unescape(value[1]) : null;
		}
		Vue.prototype.$isEmptyObject = function(obj) {
			for (var x in obj) { if (obj.hasOwnProperty(x))  return false; }
			return true;
		}
		Vue.prototype.$isValidPhoneNumber = function(phoneNumber) {
			var pattern = new RegExp(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/);
			return pattern.test(phoneNumber);
		}
		Vue.prototype.$isValidEmailAddress = function(emailAddress) {
			var pattern = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
			return pattern.test(emailAddress);
		}
		Vue.prototype.$caplitalizeWords = function(rawString) {
			if (!rawString) return
			return rawString.toLowerCase().replace('_',' ').replace(/\b\w/g, l => l.toUpperCase())
		}
		Vue.prototype.$formatDate = function(date) {
			if (!date) return
			let dateParts = date.split('-')
			return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]).toLocaleDateString("en-US", {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
			  })
		}
        Vue.prototype.$copy = function(obj, where) {
            // limitations: doesn't work if object contains methods
            return JSON.parse(JSON.stringify(obj))
        }
        Vue.prototype.$changed = function(objA, objB) {
            // limitations: doesn't account for reordering or 1 == true on checkboxes
            return JSON.stringify(objA) != JSON.stringify(objB)
        }
        Vue.prototype.$fullName = function(contact) {
			if (!contact.company_name && !contact.first_name && !contact.last_name) return ''
            let fullName = ''
            if (contact.first_name) { fullName += contact.first_name + ' ' }
            if (contact.middle_name) { fullName += contact.middle_name + ' ' }
            if (contact.last_name) { fullName += contact.last_name + ' ' }
            if (contact.suffix) { fullName += contact.suffix + ' ' }
            if (fullName == '') { fullName = contact.company_name }
            return fullName.trim()
        }
		Vue.prototype.$isValidAddress = function(address) {
			let missingField = null
			let requiredFields = ['address_1', 'city', 'state', 'zip_code']
			if (address.section == 'billing') {
				requiredFields.push('phone_number', 'email_address')
			} else {
				requiredFields.unshift('full_name')
			}
			let valid = true
			let message = null
			// Validate name combinations
			if (address.section == 'billing' && (!address.first_name || !address.last_name) && !address.company_name) {
				if (!address.first_name) {
					missingField = 'first_name'
				} else if (!address.last_name) {
					missingField = 'last_name'
				} else {
					missingField = 'company_name'
				}
				return { valid: false, missing_field: missingField, message: 'First and Last Name or Company Name are required.' }
			}
			// Validate required fields
			for (let field of requiredFields) {
				if (!address[field]) {
					valid = false
					missingField = field
					break
				}
			}
			if (!valid) return { valid: false, missing_field: missingField }
			// Validate valid email, phone
			if ('phone_number' in requiredFields && !isValidPhoneNumber(address.phone_number)) return { valid: false, missing_field: 'phone_number', message: 'Please provide a valid Phone Number.' }
			if ('email_address' in requiredFields && !isValidEmailAddress(address.email_address)) return { valid: false, missing_field: 'email_address', message: 'Please provide a valid Email Address.' }
			return { valid: true }
		}
        Vue.prototype.$isValidCreditCard = function(creditCardNumber, returnType) {
			var visaPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
			var mastPattern = /^(?:5[1-5][0-9]{14})$/;
			var amexPattern = /^(?:3[47][0-9]{13})$/;
			var discPattern = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;

			var isVisa = visaPattern.test(creditCardNumber) === true;
		    var isMast = mastPattern.test(creditCardNumber) === true;
		    var isAmex = amexPattern.test(creditCardNumber) === true;
		    var isDisc = discPattern.test(creditCardNumber) === true;
		    if (isVisa || isMast || isAmex || isDisc) {
                if (!returnType) {
    		        // at least one regex matches, so the card number is valid.
    				return true
                }
		        if (isVisa) {
		            return 'isVisa'
		        }
		        else if(isMast) {
		             return 'isMasterCard'
		        }
		        else if(isAmex) {
		            return 'isAmex'
		        }
		        else if(isDisc) {
		            return 'isDiscover'
		        }
		    } else {
		        return false
		    }
		},
		Vue.prototype.$formatFileName = function(word, maxLength=255) {
			let parsedWord = word.trim()

			// removes or replaces " " and "/" to "-", most special chars, double dash, trailing dash/underscore
			parsedWord = parsedWord
			.replace(/[/\s]+/g, '-') 
			.replace(/[^a-zA-Z0-9_-]/g, '') 
			.replace(/[-_]{2,}/g, '-') 
			.replace(/^[-_]+|[-_]+$/g, '');

			if (parsedWord.length > maxLength) {
				parsedWord = parsedWord.substring(0, maxLength); 
			}

			return parsedWord;
		},
		  
		Vue.prototype.$toWords = function(n) {
			const arr = x => Array.from(x);
			const num = x => Number(x) || 0;
			const str = x => String(x);
			const isEmpty = xs => xs.length === 0;
			const take = n => xs => xs.slice(0,n);
			const drop = n => xs => xs.slice(n);
			const reverse = xs => xs.slice(0).reverse();
			const comp = f => g => x => f (g (x));
			const not = x => !x;
			const chunk = n => xs => isEmpty(xs) ? [] : [take(n)(xs), ...chunk (n) (drop (n) (xs))];
			let a = ['', 'one', 'two', 'three', 'four',
			'five', 'six', 'seven', 'eight', 'nine',
			'ten', 'eleven', 'twelve', 'thirteen', 'fourteen',
			'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
			let b = ['', '', 'twenty', 'thirty', 'forty',
			'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
			let g = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion',
			'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion'];
			// this part is really nasty still
			// it might edit this again later to show how Monoids could fix this up
			let makeGroup = ([ones,tens,huns]) => {
				return [
				  num(huns) === 0 ? '' : a[huns] + ' hundred ',
				  num(ones) === 0 ? b[tens] : b[tens] && b[tens] + '-' || '',
				  a[tens+ones] || a[ones]
				].join('');
			}
			// "thousands" constructor; no real good names for this, i guess
			let thousand = (group,i) => group === '' ? group : `${group} ${g[i]}`
			// execute !
			if (typeof n === 'number') return this.$toWords(String(n));
			if (n === '0')             return 'zero';
			return comp (chunk(3)) (reverse) (arr(n))
					.map(makeGroup)
					.map(thousand)
					.filter(comp(not)(isEmpty))
					.reverse()
					.join(' ');
		}
		Vue.prototype.$randomString = function(length) {
		    var text = ""
		    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
		    for(var i = 0; i < length; i++) {
		        text += possible.charAt(Math.floor(Math.random() * possible.length))
		    }
		    return text
		}
        Vue.prototype.$hexToRGB = function(color) {
            color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

            var r = color >> 16;
            var g = color >> 8 & 255;
            var b = color & 255;

            return r + "," + b + "," + g
        }
        Vue.prototype.$lightOrDark = function(color) {
            if (!color) return

            // Variables for red, green, blue values
            var r, g, b, hsp;

            // Check the format of the color, HEX or RGB?
            if (color.match(/^rgb/)) {
                // If HEX --> store the red, green, blue values in separate variables
                color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

                r = color[1];
                g = color[2];
                b = color[3];
            }
            else {
                // If RGB --> Convert it to HEX: http://gist.github.com/983661
                color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

                r = color >> 16;
                g = color >> 8 & 255;
                b = color & 255;
            }

            // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
            hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
            );

            // Using the HSP value, determine whether the color is light or dark
            if (hsp > 127.5) {
                return 'light';
            }
            else {
                return 'dark';
            }
        }
        Vue.prototype.$formatPrice = function(price) {
            if (!price) return
            price = price.toString()
            if (price.indexOf('.') > -1) {
                var parts = price.split('.')
            } else {
                var parts = [price]
            }
            var leftOfDecimal = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            var rightOfDecimal = parts[1] || "00"
            return `<sup>$</sup>${leftOfDecimal}<sup>${rightOfDecimal}</sup>`
        }
        Vue.prototype.$formatCurrency = function(price) {
            if (!price) return '$0.00'
			let roundedPrice = Math.round(price * 100) / 100
            price = roundedPrice.toString()
            if (price.indexOf('.') > -1) {
                var parts = price.split('.')
            } else {
                var parts = [price]
            }
            var leftOfDecimal = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            var rightOfDecimal = parts[1] ? parts[1].padEnd(2,0) : "00"
            return '$' + leftOfDecimal + '.' + rightOfDecimal
        }
        Vue.prototype.$formatPercent = function(percent) {
            if (!percent) return '0.0%'
			let roundedPercent = Math.round(percent * 100) / 100
            percent = roundedPercent.toString()
            if (percent.indexOf('.') > -1) {
                var parts = percent.split('.')
            } else {
                var parts = [percent]
            }
            var leftOfDecimal = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            var rightOfDecimal = parts[1] ? parts[1].padEnd(1,0) : "0"
            return leftOfDecimal + '.' + rightOfDecimal + "%"
        }
        Vue.prototype.$findKeyInObj = function(key, object) {
            var i = 0
            var found = {}
            while (i < Object.keys(object).length) {
                if (Object.keys(object)[i].indexOf(key) > -1) {
                    found[Object.keys(object)[i]] = object[Object.keys(object)[i]]
                }
                i++
            }
            return found
        }
		Vue.prototype.$mapURLFromAddress = function(data) {
			let mapLink = data['address_1'] + "+";
			if (data['address_2']) {
				mapLink += data['address_2'] + "+";
			}
			mapLink += data['city'] + "+";
			mapLink += data['state'] + "+";
			mapLink += data['zip_code'] + "+";
			mapLink += "&hl=en&t=m&z=11";
			return "https://maps.google.com/maps?q=" + encodeURI(mapLink)
		}
		Vue.prototype.MONTHS_LIST = [
			{ code: "01", description: "January" },
			{ code: "02", description: "February" },
			{ code: "03", description: "March" },
			{ code: "04", description: "April" },
			{ code: "05", description: "May" },
			{ code: "06", description: "June" },
			{ code: "07", description: "July" },
			{ code: "08", description: "August" },
			{ code: "09", description: "September" },
			{ code: "10", description: "October" },
			{ code: "11", description: "November" },
			{ code: "12", description: "December" }
		]
		Vue.prototype.STATES_LIST = {
		    "AL": "Alabama",
		    "AK": "Alaska",
		    "AS": "American Samoa",
		    "AZ": "Arizona",
		    "AR": "Arkansas",
		    "CA": "California",
		    "CO": "Colorado",
		    "CT": "Connecticut",
		    "DE": "Delaware",
		    "DC": "District Of Columbia",
		    "FM": "Federated States Of Micronesia",
		    "FL": "Florida",
		    "GA": "Georgia",
		    "GM": "Guam",
		    "HI": "Hawaii",
		    "ID": "Idaho",
		    "IL": "Illinois",
		    "IN": "Indiana",
		    "IA": "Iowa",
		    "KS": "Kansas",
		    "KY": "Kentucky",
		    "LA": "Louisiana",
		    "ME": "Maine",
		    "MH": "Marshall Islands",
		    "MD": "Maryland",
		    "MA": "Massachusetts",
		    "MI": "Michigan",
		    "MN": "Minnesota",
		    "MS": "Mississippi",
		    "MO": "Missouri",
		    "MT": "Montana",
		    "NE": "Nebraska",
		    "NV": "Nevada",
		    "NH": "New Hampshire",
		    "NJ": "New Jersey",
		    "NM": "New Mexico",
		    "NY": "New York",
		    "NC": "North Carolina",
		    "ND": "North Dakota",
		    "MP": "Northern Mariana Islands",
		    "OH": "Ohio",
		    "OK": "Oklahoma",
		    "OR": "Oregon",
		    "PW": "Palau",
		    "PA": "Pennsylvania",
		    "PR": "Puerto Rico",
		    "RI": "Rhode Island",
		    "SC": "South Carolina",
		    "SD": "South Dakota",
		    "TN": "Tennessee",
		    "TX": "Texas",
		    "UT": "Utah",
		    "VT": "Vermont",
		    "VI": "Virgin Islands",
		    "VA": "Virginia",
		    "WA": "Washington",
		    "WV": "West Virginia",
		    "WI": "Wisconsin",
		    "WY": "Wyoming"
		}
		Vue.prototype.COUNTRIES_LIST = {
			"AF": "Afghanistan",
			"AA": "Albania",
			"AN": "Algeria",
			"AD": "Andorra",
			"AO": "Angola",
			"AE": "Anguilla",
			"AI": "Antigua and Barbuda",
			"AT": "Argentina",
			"AP": "Armenia",
			"AJ": "Aruba",
			"AH": "Ashmore and Cartier Islands",
			"AS": "Australia",
			"AU": "Austria",
			"AV": "Azerbaijan",
			"AQ": "Azores Islands",
			"BD": "Bahamas, The",
			"BE": "Bahrain/Bahrein",
			"BW": "Balearic Islands",
			"BL": "Bangladesh",
			"BB": "Barbados",
			"BF": "Bassa da India",
			"BY": "Belarus",
			"BG": "Belgium",
			"BH": "Belize",
			"DH": "Benin",
			"BM": "Bermuda",
			"BN": "Bhutan",
			"BV": "Bolivia",
			"NX": "Bonaire",
			"BP": "Bosnia and Herzegovina",
			"BT": "Botswana",
			"BQ": "Bouvet Island",
			"BZ": "Brazil",
			"BO": "British Indian Ocean Territory",
			"BS": "British Solomon Islands",
			"VB": "British Virgin Islands",
			"BX": "Brunei",
			"BU": "Bulgaria",
			"UV": "Burkina Faso",
			"BR": "Burma",
			"BI": "Burundi",
			"BY": "Byelarus",
			"CJ": "Cambodia",
			"CM": "Cameroon",
			"CD": "Canada",
			"ZI": "Canary Islands",
			"CV": "Cape Verde Islands",
			"CP": "Cayman Islands",
			"CW": "Central African Rep",
			"CF": "Chad",
			"CQ": "Chile",
			"RC": "China, Peoples Republic of",
			"HR": "Christmas Island",
			"DB": "Clipperton Island",
			"DD": "Cocos (Keeling) Islands",
			"CB": "Colombia",
			"DG": "Comoros, Fed Islamic Rep",
			"RB": "Congo, Rep of",
			"DI": "Cook Islands",
			"DJ": "Coral Sea Islands",
			"CR": "Costa Rica",
			"KC": "Croatia",
			"CC": "Cuba",
			"CS": "Cyprus",
			"EZ": "Czech Republic",
			"DK": "Denmark",
			"DN": "Djibouti",
			"DM": "Dominica",
			"DR": "Dominican Republic",
			"PC": "Ducie Islands",
			"EU": "Ecuador",
			"EY": "Egypt",
			"EL": "El Salvador",
			"EN": "England",
			"EK": "Equatorial Guinea",
			"ET": "Eritrea",
			"ES": "Estonia",
			"EO": "Ethiopia",
			"ER": "Europa Island",
			"FA": "Falkland Islands",
			"FO": "Faroe Islands",
			"FJ": "Fiji Islands",
			"FD": "Finland",
			"FN": "France",
			"FG": "French Guiana",
			"FP": "French Polynesia",
			"FR": "French Southern/Antartic Lands",
			"GB": "Gabon",
			"GK": "Gambia",
			"GZ": "Gaza",
			"GD": "Georgia",
			"GS": "Georgia/S Sandwich Islands",
			"GE": "Germany, Federal Rep of",
			"GG": "Ghana",
			"GI": "Gibraltar",
			"GO": "Glorioso Islands",
			"GC": "Greece",
			"GN": "Greenland",
			"GJ": "Grenada",
			"GP": "Guadeloupe",
			"GT": "Guatemala",
			"GF": "Guernsey",
			"GI": "Guinea",
			"PG": "Guinea-Bissau",
			"GY": "Guyana/Incl French Guiana",
			"HT": "Haiti",
			"HE": "Heard Island and McDonald Islands",
			"BP": "Herzegovina, Bosnia and",
			"HD": "Honduras",
			"HK": "Hong Kong",
			"HU": "Hungary",
			"IC": "Iceland",
			"II": "India",
			"IO": "Indonesia",
			"IR": "Iran",
			"IQ": "Iraq",
			"IE": "Ireland",
			"FA": "Islas Malvinas (Falkland Islands)",
			"IB": "Isle of Man",
			"IS": "Israel",
			"IT": "Italy",
			"IY": "Ivory Coast",
			"JM": "Jamaica",
			"JN": "Jan Mayen",
			"JA": "Japan",
			"JE": "Jersey",
			"JO": "Jordan",
			"JU": "Juan de Nova Island",
			"KT": "Kazakhstan",
			"KE": "Kenya",
			"KB": "Kiribati",
			"KV": "Kosovo",
			"KU": "Kuwait",
			"KZ": "Kyrgyzstan",
			"LS": "Laos",
			"LT": "Latvia",
			"LN": "Lebanon",
			"LE": "Lesotho",
			"LB": "Liberia",
			"LY": "Libya",
			"LI": "Liechtenstein",
			"LH": "Lithuania",
			"LX": "Luxembourg",
			"OC": "Macau",
			"ZD": "Macedonia",
			"MP": "Madagascar/Malagasy Republic",
			"IM": "Madeira Islands",
			"MF": "Malawi",
			"MZ": "Malaysia",
			"MV": "Maldives",
			"ML": "Mali",
			"MY": "Malta",
			"KH": "Manahiki Island",
			"ZB": "Martinique",
			"MU": "Mauritania",
			"UM": "Mauritius",
			"YO": "Mayotte",
			"MM": "Mexico",
			"FS": "Micronesia, Fed States of",
			"LD": "Moldova",
			"MJ": "Monaco",
			"MG": "Mongolia",
			"RR": "Montserrat",
			"XB": "Montenegro",
			"MQ": "Morocco",
			"ZO": "Mozambique",
			"SJ": "Namibia",
			"NR": "Nauru",
			"NP": "Nepal",
			"NE": "Netherlands",
			"NX": "Netherlands Antilles/Bonaire",
			"NQ": "New Caledonia",
			"HN": "New Hebrides",
			"NZ": "New Zealand",
			"NU": "Nicaragua",
			"NN": "Niger",
			"NG": "Nigeria",
			"IU": "Niue",
			"OF": "Norfolk Island",
			"KN": "North Korea",
			"NI": "Northern Ireland",
			"NW": "Norway",
			"OI": "Okinawa",
			"OM": "Oman",
			"PK": "Pakistan",
			"PD": "Palau, Republic of",
			"PM": "Panama",
			"NO": "Papua New Guinea",
			"PF": "Paracel Islands",
			"PV": "Paraguay",
			"PU": "Peru",
			"PI": "Philippines",
			"PC": "Pitcairn Islands",
			"PO": "Poland",
			"PT": "Portugal",
			"QA": "Qatar",
			"RB": "Republic of Congo",
			"RE": "Reunion",
			"RU": "Romania/Rumania",
			"RA": "Russia",
			"RF": "Russian Federation",
			"RW": "Rwanda",
			"LU": "Saint Lucia",
			"PS": "Saint Pierre and Miquelon",
			"VV": "Saint Vincent and the Grenadines",
			"SH": "San Marino",
			"TP": "Sao Tome and Principe",
			"SB": "Saudi Arabia",
			"SS": "Scotland",
			"SG": "Senegal",
			"XA": "Serbia",
			"SE": "Seychelles",
			"SA": "Sierra Leone",
			"SR": "Singapore",
			"LF": "Slovakia",
			"LO": "Slovenia",
			"RV": "Socialist Republic of Vietnam",
			"BS": "Solomon Islands",
			"SM": "Somalia",
			"SF": "South Africa",
			"GS": "South Georgia and the South Sandwich Islands",
			"KO": "South Korea",
			"SJ": "South-West Africa/Namibia",
			"SP": "Spain",
			"TE": "Spratly Islands",
			"CY": "Sri Lanka",
			"TS": "St Christopher/St Kitts and Nevis",
			"SU": "Sudan",
			"ZC": "Suriname",
			"SV": "Svalbard",
			"SW": "Swaziland",
			"SQ": "Sweden",
			"SZ": "Switzerland",
			"SY": "Syria",
			"TW": "Taiwan, Republic of China",
			"TJ": "Tajikistan",
			"TZ": "Tanzania, United Rep of",
			"TH": "Thailand",
			"TO": "Togo",
			"TK": "Tokelau",
			"TG": "Tonga",
			"TQ": "Tongareva",
			"TT": "Trinidad and Tobago",
			"TM": "Tromelin Island",
			"TD": "Trust Territory of the Pacific Islands",
			"TF": "Tuamotu Archipelago",
			"TU": "Tunisia",
			"TY": "Turkey",
			"UR": "Turkmenistan",
			"TR": "Turks and Caicos Islands",
			"TV": "Tuvalu",
			"UG": "Uganda",
			"UK": "Ukraine",
			"TC": "United Arab Emirates",
			"XX": "Unknown",
			"XY": "Unreported",
			"UY": "Uruguay",
			"UZ": "Uzbekistan, Republic of",
			"HN": "Vanuatu, Rep of",
			"VY": "Vatican City",
			"VZ": "Venezuela",
			"RV": "Vietnam, Socialist Rep of",
			"WL": "Wales",
			"WF": "Wallis and Futuna",
			"WB": "West Bank",
			"WN": "West Indies Islands",
			"RS": "Western Sahara",
			"WS": "Western Samoa",
			"YE": "Yemen",
			"YG": "Yugoslavia",
			"ZR": "Zaire",
			"ZM": 'Zambia', 
			"RH": "Zimbabwe",
			"YY": "Other"
		}
        Vue.directive('focus', {
			// When the bound element is inserted into the DOM...
			inserted: function (el) {
				// Focus the element
				el.focus()
			}
		})
		Vue.directive('click-outside', {
			bind: function (el, binding, vnode) {
				el.event = function (event) {
					// here I check that click was outside the el and his childrens
					if (!(el == event.target || el.contains(event.target))) {
						// and if it did, call method provided in attribute value
						vnode.context[binding.expression](event);
					}
				}
				document.body.addEventListener('click', el.event)
			},
			unbind: function (el) {
				document.body.removeEventListener('click', el.event)
			}
		})
        Vue.directive('linkify', {
			bind: function (el, binding, vnode) {
				el.innerHTML = el.innerHTML.replace(/(https:|http:)\/\/[a-z0-9\/:.-]+/gi, "<a href='$&' target='_blank'>$&</a>")
			}
		})
        String.prototype.dasherize = function() {
            var _this = this.replace(' &', '');
            return _this.replace(/^([A-Z]*)|[\s\._](\w)/g, function(match, p1, p2, offset) {
                if (p2) return "-" + p2.toLowerCase();
                return p1.toLowerCase();
            });
        }
        String.prototype.capitalizeWords = function() {
            if (!this || typeof this !== 'string') return ''
            let string = this.toLowerCase()
			return string.replace('_',' ').replace(/\b\w/g, l => l.toUpperCase())
        }
    }
}

export default Functions;
